import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import { useUser } from "../Context/UserContext";

const BillGenerate = () => {
  const { productionCenterId, token } = useUser();

  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(false);

  const getHeaders = () => ({
    Authorization: `Bearer ${token}`,
  });

  const fetchBills = async () => {
    if (!productionCenterId) return;

    setLoading(true);
    try {
      const res = await fetch(
        `/api/users/farmer-request/?production_center_id=${productionCenterId}`,
        { headers: getHeaders() }
      );

      const data = await res.json();

      // ✅ GROUP BY request_id
      const grouped = {};

      data.forEach(item => {
        if (!grouped[item.request_id]) {
          grouped[item.request_id] = {
            request_id: item.request_id,
            farmer_name: item.farmer_name,
            mobile: item.mobile_number,
            village: item.village,
            items: []
          };
        }

        grouped[item.request_id].items.push(item);
      });

      setBills(Object.values(grouped));

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBills();
  }, [productionCenterId]);

  return (
    <Box p={3}>
      <Typography variant="h5" mb={2}>
        Farmer Bills
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : (
        bills.map((bill) => (
          <Paper key={bill.request_id} sx={{ p: 3, mb: 3 }}>
            
            {/* HEADER */}
            <Typography><b>Request ID:</b> {bill.request_id}</Typography>
            <Typography><b>Farmer:</b> {bill.farmer_name}</Typography>
            <Typography><b>Mobile:</b> {bill.mobile}</Typography>
            <Typography><b>Village:</b> {bill.village}</Typography>

            <Box mt={2}>
              <Typography variant="h6">Items</Typography>

              {bill.items.map((item) => (
                <Box
                  key={item.item_id}
                  display="flex"
                  justifyContent="space-between"
                  borderBottom="1px solid #eee"
                  py={1}
                >
                  <span>{item.species_name}</span>
                  <span>Qty: {item.approved_quantity}</span>
                  <span>Status: {item.status}</span>
                </Box>
              ))}
            </Box>

          </Paper>
        ))
      )}
    </Box>
  );
};

export default BillGenerate;